document.addEventListener('DOMContentLoaded', function () {
  const menus = document.querySelectorAll('.condensed-mega-menu');

  menus.forEach((menu) => {
    const primaryItems = Array.from(menu.querySelectorAll('.condensed-mega-menu__primary-item'));
    const contentPanels = Array.from(menu.querySelectorAll('.condensed-mega-menu__panel'));
    const promoPanels = Array.from(menu.querySelectorAll('.condensed-mega-menu__promo-panel'));

    if (!primaryItems.length) return;

    function activatePanel(targetId) {
      primaryItems.forEach((item) => {
        const isActive = item.dataset.condensedTarget === targetId;
        item.classList.toggle('is-active', isActive);

        const link = item.querySelector('.condensed-mega-menu__primary-link');
        if (link && link.hasAttribute('aria-expanded')) {
          link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      contentPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === targetId);
      });

      promoPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.condensedTarget === targetId);
      });
    }

    primaryItems.forEach((item) => {
      const targetId = item.dataset.condensedTarget;
      if (!targetId) return;

      item.addEventListener('mouseenter', function () {
        activatePanel(targetId);
      });

      item.addEventListener('focusin', function () {
        activatePanel(targetId);
      });
    });
  });
});